<div class="schedule-view h-100">
  @if (!readonly() && (showSubmit() || showClear())) {
    <div class="schedule-view__action" [ngClass]="{ 'schedule-view__action-open': isFilled() }">
      @if (showSubmit() && isFilled()) {
        <button mat-button (click)="onSubmitChanges()">
          Submit
          <mat-icon color="accent">send</mat-icon>
        </button>
      }
      @if (showClear() && isFilled()) {
        <button mat-button (click)="onClear()" matTooltip="Discard changes">
          Discard changes
          <mat-icon color="warn">close</mat-icon>
        </button>
      }
    </div>
  }
  @if (hasGps()) {
    <rc-generic-schedule
      [title]="scheduleTitles()?.GPS || 'GPS Schedule'"
      [addScheduleText]="'Add GPS Schedule'"
      scheduleType="GPS"
      [readonly]="readonly()"
      [hideChangedSchedules]="hideChangedSchedules()"
      [showScheduleRemove]="showScheduleRemove()"
      [permanentStartDate]="permanentStartDate()"
      [permanentEndDate]="effectivePermanentEndDate()"
      [isRulesDeletable]="isRulesDeletable()"
      [isDisabledByScheduleResponse]="
        remoteSchedules()?.GPS && selectedCollarIds()?.length
          ? remoteSchedules()?.GPS?.length !== selectedCollarIds()?.length
          : false
      "
      [isDisabledByEmptySchedule]="isDisabledByEmptySchedule('GPS')"
      [allowedCollars]="remoteSchedules()?.GPS"
      [attr.data-testid]="'GPS-schedule'"
      [showOverrideWarning]="shouldShowWarning('GPS')"
      [showLoadFromTemplates]="showLoadFromTemplates()"
      [showSaveAsTemplate]="showSaveAsTemplate()"
      [showImportJson]="showImportJson()"
      [showLoadGpsXFile]="shouldShowGpsXFileButton('GPS')"
      [gpsXFileAccept]="gpsXFileAcceptFor('GPS')"
      [ignoreShortHeaderMessage]="ignoreShortHeaderMessage()"
      [(showPreview)]="showPreview"
      [warningMessages]="warningMessagesFor('GPS')"
      [errorMessages]="errorMessagesFor('GPS')"
      [hideRules]="hideRulesFor('GPS')"
      [initializeSequenceByAddSchedule]="true"
    />
  }

  @if (hasSolexGps()) {
    <div class="schedule-view__info">
      <vectronic-alert type="warning">
        High and low energy schedules are set in the skip count. To change the GPS schedule for
        Solex collars, please contact your Vectronic contact.
      </vectronic-alert>
    </div>
    <rc-generic-schedule
      [title]="scheduleTitles()?.SOLEX_GPS || 'Solex GPS Schedule'"
      [addScheduleText]="'Add Solex GPS Schedule'"
      scheduleType="SOLEX_GPS"
      [readonly]="readonly()"
      [showLoadFromTemplates]="showLoadFromTemplates()"
      [showSaveAsTemplate]="showSaveAsTemplate()"
      [showImportJson]="showImportJson()"
      [showLoadGpsXFile]="shouldShowGpsXFileButton('SOLEX_GPS')"
      [gpsXFileAccept]="gpsXFileAcceptFor('SOLEX_GPS')"
      [hideChangedSchedules]="hideChangedSchedules()"
      [showScheduleRemove]="showScheduleRemove()"
      [permanentStartDate]="permanentStartDate()"
      [permanentEndDate]="effectivePermanentEndDate()"
      [isRulesDeletable]="isRulesDeletable()"
      [isDisabledByScheduleResponse]="
        remoteSchedules()?.SOLEX_GPS && selectedCollarIds()?.length
          ? remoteSchedules()?.SOLEX_GPS?.length !== selectedCollarIds()?.length
          : false
      "
      [isDisabledByEmptySchedule]="isDisabledByEmptySchedule('SOLEX_GPS')"
      [allowedCollars]="remoteSchedules()?.SOLEX_GPS"
      [attr.data-testid]="'SOLEX_GPS-schedule'"
      [showOverrideWarning]="shouldShowWarning('SOLEX_GPS')"
      [ignoreShortHeaderMessage]="ignoreShortHeaderMessage()"
      [(showPreview)]="showPreview"
      [warningMessages]="warningMessagesFor('SOLEX_GPS')"
      [hideRules]="hideRulesFor('SOLEX_GPS')"
      [initializeSequenceByAddSchedule]="true"
    />
  }
  @if (showProximityWarning()) {
    <vectronic-alert type="error">
      Warning: Proximity Mode is currently OFF. You can enable it in section External Sensors.
    </vectronic-alert>
  }
  @if (hasProximity()) {
    <rc-generic-schedule
      [title]="scheduleTitles()?.PROXIMITY || 'Proximity Schedule'"
      [addScheduleText]="'Add Proximity Schedule'"
      scheduleType="PROXIMITY"
      [allowEmptySchedule]="showRemoveSchedule()"
      [readonly]="readonly()"
      [showReset]="showReset() && hasUserProximity()"
      [showScheduleRemove]="showScheduleRemove()"
      [hideChangedSchedules]="hideChangedSchedules()"
      [isRulesDeletable]="isRulesDeletable()"
      [permanentStartDate]="permanentStartDate()"
      [permanentEndDate]="effectivePermanentEndDate()"
      [isDisabledByScheduleResponse]="
        remoteSchedules()?.PROXIMITY && selectedCollarIds()?.length
          ? remoteSchedules()?.PROXIMITY?.length !== selectedCollarIds()?.length
          : false
      "
      [isDisabledByEmptySchedule]="isDisabledByEmptySchedule('PROXIMITY')"
      [allowedCollars]="remoteSchedules()?.PROXIMITY"
      [attr.data-testid]="'PROXIMITY-schedule'"
      [showOverrideWarning]="shouldShowWarning('PROXIMITY')"
      [showLoadFromTemplates]="showLoadFromTemplates()"
      [showSaveAsTemplate]="showSaveAsTemplate()"
      [showImportJson]="showImportJson()"
      [showLoadGpsXFile]="shouldShowGpsXFileButton('PROXIMITY')"
      [gpsXFileAccept]="gpsXFileAcceptFor('PROXIMITY')"
      [ignoreShortHeaderMessage]="ignoreShortHeaderMessage()"
      [(showPreview)]="showPreview"
      [warningMessages]="warningMessagesFor('PROXIMITY')"
      [hideRules]="hideRulesFor('PROXIMITY')"
      [initializeSequenceByAddSchedule]="true"
    />
  }
  @if (hasBeacon()) {
    <rc-generic-schedule
      [title]="scheduleTitles()?.VHF || 'Beacon Schedule'"
      [addScheduleText]="'Add Beacon Schedule'"
      scheduleType="VHF"
      [readonly]="readonly()"
      [hideChangedSchedules]="hideChangedSchedules()"
      [showScheduleRemove]="showScheduleRemove()"
      [permanentStartDate]="permanentStartDate()"
      [permanentEndDate]="effectivePermanentEndDate()"
      [isRulesDeletable]="isRulesDeletable()"
      [isDisabledByScheduleResponse]="
        remoteSchedules()?.VHF && selectedCollarIds()?.length
          ? remoteSchedules()?.VHF?.length !== selectedCollarIds()?.length
          : false
      "
      [isDisabledByEmptySchedule]="isDisabledByEmptySchedule('VHF')"
      [allowedCollars]="remoteSchedules()?.VHF"
      [attr.data-testid]="'VHF-schedule'"
      [showOverrideWarning]="shouldShowWarning('VHF')"
      [showLoadFromTemplates]="showLoadFromTemplates()"
      [showSaveAsTemplate]="showSaveAsTemplate()"
      [showImportJson]="showImportJson()"
      [showLoadGpsXFile]="shouldShowGpsXFileButton('VHF')"
      [gpsXFileAccept]="gpsXFileAcceptFor('VHF')"
      [ignoreShortHeaderMessage]="ignoreShortHeaderMessage()"
      [(showPreview)]="showPreview"
      [warningMessages]="warningMessagesFor('VHF')"
      [hideRules]="hideRulesFor('VHF')"
      [initializeSequenceByAddSchedule]="true"
    />
  }
  @if (hasCommunication()) {
    <rc-generic-schedule
      [title]="scheduleTitles()?.COMMUNICATION || 'Communication Schedule'"
      [addScheduleText]="'Add Communication Schedule'"
      scheduleType="COMMUNICATION"
      [allowEmptySchedule]="showRemoveSchedule()"
      [readonly]="readonly()"
      [showReset]="showReset() && hasUserCommunication()"
      [showScheduleRemove]="showScheduleRemove()"
      [hideChangedSchedules]="hideChangedSchedules()"
      [isRulesDeletable]="isRulesDeletable()"
      [permanentStartDate]="permanentStartDate()"
      [permanentEndDate]="effectivePermanentEndDate()"
      [isDisabledByScheduleResponse]="
        remoteSchedules()?.COMMUNICATION && selectedCollarIds()?.length
          ? remoteSchedules()?.COMMUNICATION?.length !== selectedCollarIds()?.length
          : false
      "
      [isDisabledByEmptySchedule]="isDisabledByEmptySchedule('COMMUNICATION')"
      [allowedCollars]="remoteSchedules()?.COMMUNICATION"
      [attr.data-testid]="'COMMUNICATION-schedule'"
      [showOverrideWarning]="shouldShowWarning('COMMUNICATION')"
      [showLoadFromTemplates]="showLoadFromTemplates()"
      [showSaveAsTemplate]="showSaveAsTemplate()"
      [showImportJson]="showImportJson()"
      [showLoadGpsXFile]="shouldShowGpsXFileButton('COMMUNICATION')"
      [gpsXFileAccept]="gpsXFileAcceptFor('COMMUNICATION')"
      [ignoreShortHeaderMessage]="ignoreShortHeaderMessage()"
      [(showPreview)]="showPreview"
      [warningMessages]="warningMessagesFor('COMMUNICATION')"
      [hideRules]="hideRulesFor('COMMUNICATION')"
      [initializeSequenceByAddSchedule]="true"
    />
  }
  <!--
      @if (hasExternalSensor()) {
        <rc-external-sensor-schedule
          [readonly]="readonly()"
          [scheduleResponse]="scheduleResponse()"
          [selectedCollarIds]="selectedCollarIds()"
          [collarsWithNoShortHeaderFormat]="collarsWithNoShortHeaderFormat()"
        ></rc-external-sensor-schedule>
      }
      -->
  @if (showNoCameraWarning()) {
    <vectronic-alert type="error">
      No Camera assigned to the collar. You can assign a camera in the section Sensors.
    </vectronic-alert>
  }
  @if (showCameraModeWarning()) {
    <vectronic-alert type="error">
      Warning: Camera Mode is currently OFF. You can enable it in section Sensors.
    </vectronic-alert>
  }
  @if (showNoCameraPermissionWarning()) {
    @if (remoteCommandProviderService?.isAdmin) {
      <vectronic-alert type="error">Camera for cameraID does not exist.</vectronic-alert>
    } @else {
      <vectronic-alert type="error"
        >You have no permission to the connected camera.</vectronic-alert
      >
      <button
        class="schedule-view__action-button"
        mat-button
        (click)="clickSendCameraRequestPermission.emit()"
      >
        Send request permission to camera
        <mat-icon color="accent">add</mat-icon>
      </button>
    }
  }
  @if (hasCamera()) {
    <rc-camera-schedule
      [title]="scheduleTitles()?.CAMERA || 'Camera Schedule'"
      [readonly]="readonly()"
      [isMoreThanOneCameraType]="hasMultipleCameraTypes() && !readonly()"
      [selectedCollarIds]="selectedCollarIds()"
      [videoFormatsOptions]="videoFormatsOptions()"
      [photoFormatsOptions]="photoFormatsOptions()"
      [showReset]="showReset() && hasUserCamera()"
      [showRemoveSchedule]="showRemoveSchedule()"
      [hideChangedSchedules]="hideChangedSchedules()"
      [isRulesDeletable]="isRulesDeletable()"
      [showScheduleRemove]="showScheduleRemove()"
      [attr.data-testid]="'CAMERA-schedule'"
      [showOverrideWarning]="shouldShowWarning('CAMERA')"
      [hideCameraFormat]="hideCameraFormat()"
      [showLoadFromTemplates]="showLoadFromTemplates()"
      [showSaveAsTemplate]="showSaveAsTemplate()"
      [showImportJson]="showImportJson()"
      [ignoreShortHeaderMessage]="ignoreShortHeaderMessage()"
      [hasHighActivityCameraTrigger]="hasHighActivityCameraTrigger()"
      [isDisabledByEmptySchedule]="scheduleServices.hasAnyEmptySchedule()"
      [(showPreview)]="showPreview"
      [warningMessages]="warningMessagesFor('CAMERA')"
      [hideRules]="hideRulesFor('CAMERA')"
    ></rc-camera-schedule>
  }

  @if (showVfModeOffWarning()) {
    <vectronic-alert type="error">
      Warning: Virtual Fence Mode is currently OFF. You can enable it in section Virtual Fence.
    </vectronic-alert>
  }
  @if (showVfModeWarning()) {
    <div class="schedule-view__info">
      <vectronic-alert type="warning">
        Virtual Fences take effect only when Virtual Fence Mode is turned ON.
      </vectronic-alert>
    </div>
  }
  @if (hasVirtualFence()) {
    @if (warningByScheduleType()?.get('VIRTUAL_FENCE_MAP')) {
      <vectronic-alert type="warning">
        {{ warningByScheduleType()!.get('VIRTUAL_FENCE_MAP') }}
      </vectronic-alert>
    }
    <div class="schedule-view__virtual-fence h-100">
      <rc-virtual-fence-view
        [isAdmin]="isAdmin()"
        [readonly]="readonly()"
        [selectedCollarIds]="selectedCollarIds()"
        [mapPositions]="mapPositions()"
        [isPositionsLoading]="isPositionsLoading()"
        [userPreferences]="userPreferences()"
        [defaultVirtualFenceConstructionRules]="defaultVirtualFenceConstructionRules()"
        [defaultVirtualFenceCleared]="
          virtualFenceCleared() || virtualFenceService.isEmptyVirtualFence()
        "
        [attr.data-testid]="'VIRTUAL_FENCE-map'"
        (loadPositions)="loadPositions.emit($event)"
        [showOverrideWarning]="shouldShowVirtualFenceWarning()"
        [notAvailableForIds]="virtualFenceNotAvailableForIds()"
        [hideConstructionRules]="hideConstructionRules()"
      >
      </rc-virtual-fence-view>
    </div>
  }

  @if (hasVirtualFenceSchedule()) {
    <rc-generic-schedule
      [title]="scheduleTitles()?.VIRTUAL_FENCE || 'Virtual Fence Schedule'"
      [addScheduleText]="'Add Virtual Fence Schedule'"
      scheduleType="VIRTUAL_FENCE"
      [allowEmptySchedule]="showRemoveSchedule()"
      [readonly]="readonly()"
      [showReset]="showReset() && hasUserVirtualFence()"
      [showScheduleRemove]="showScheduleRemove()"
      [hideChangedSchedules]="hideChangedSchedules()"
      [isRulesDeletable]="isRulesDeletable()"
      [permanentStartDate]="permanentStartDate()"
      [permanentEndDate]="effectivePermanentEndDate()"
      [isDisabledByScheduleResponse]="
        remoteSchedules()?.VIRTUAL_FENCE && selectedCollarIds()?.length
          ? remoteSchedules()?.VIRTUAL_FENCE?.length !== selectedCollarIds()?.length
          : false
      "
      [isDisabledByEmptySchedule]="isDisabledByEmptySchedule('VIRTUAL_FENCE')"
      [allowedCollars]="remoteSchedules()?.VIRTUAL_FENCE"
      [attr.data-testid]="'VIRTUAL_FENCE-schedule'"
      [showOverrideWarning]="shouldShowWarning('VIRTUAL_FENCE')"
      [showLoadFromTemplates]="showLoadFromTemplates()"
      [showSaveAsTemplate]="showSaveAsTemplate()"
      [showImportJson]="showImportJson()"
      [showLoadGpsXFile]="shouldShowGpsXFileButton('VIRTUAL_FENCE')"
      [gpsXFileAccept]="gpsXFileAcceptFor('VIRTUAL_FENCE')"
      [ignoreShortHeaderMessage]="ignoreShortHeaderMessage()"
      [(showPreview)]="showPreview"
      [warningMessages]="warningMessagesFor('VIRTUAL_FENCE')"
      [hideRules]="hideRulesFor('VIRTUAL_FENCE')"
      [initializeSequenceByAddSchedule]="true"
    />
  }
</div>
